import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ButtonModule, DialogModule, DropdownModule, PaginatorModule } from 'primeng';
import { VmePipesModule } from '../../../../../vme-pipes.module';
import { CommonModule } from '@angular/common';
import { VehicleRegComponent } from '../../../../vehicle-reg/vehicle-reg.component';
import { RouteRecommendationService } from '../../../../../services/route-recommendation.service';
import moment from 'moment';
import { IRouteGrabbedJob } from '../../../../../interfaces/route-recommendations/route-grabbed';

@Component({
  selector: 'route-itinerary-confirmation-popup',
  templateUrl: './route-itinerary-confirmation-popup.component.html',
  standalone: true,
  styleUrls: ['./route-itinerary-confirmation-popup.component.scss'],
  imports: [
    DialogModule,
    DropdownModule,
    PaginatorModule,
    ButtonModule,
    VmePipesModule,
    CommonModule,
    VehicleRegComponent,
  ],
})
export class RouteItineraryConfirmationPopupComponent implements OnChanges {
  @Input() showConfirmationDialog: boolean;
  @Output() showConfirmationDialogChange: EventEmitter<boolean> = new EventEmitter();
  @Input() jobId!: number;
  @Input() isVME: boolean = false;
  job: IRouteGrabbedJob;
  loading: boolean = true;
  constructor(private routeRecommendationService: RouteRecommendationService) {}

  getRouteGrabbedConfirmation() {
    if (this.jobId == null) {
      return;
    }
    this.loading = true;
    this.routeRecommendationService
      .getRouteGrabbedConfirmation(this.jobId)
      .then((job: IRouteGrabbedJob) => {
        this.job = job;
      });
    this.loading = false;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.getRouteGrabbedConfirmation();
  }

  backToSearch() {
    this.routeRecommendationService.refreshSearchEvent.emit();
    this.showConfirmationDialog = false;
    this.showConfirmationDialogChange.emit(false);
  }

  viewJob() {
    window.open('/app/jobscreen/' + this.jobId, '_blank');
  }

  hideDialog() {
    this.showConfirmationDialogChange.emit(false);
    this.routeRecommendationService.refreshSearchEvent.emit();
  }

  isSameDay(date1: Date, date2: Date) {
    return moment(date1).isSame(moment(date2), 'day');
  }
}
